import { useEffect, useState } from "react";

/**
 * Preloads an image and returns true when it is cached or fully loaded.
 * Returns true immediately if no URL is provided.
 */
export const useImagePreloader = (imageUrl?: string | null): boolean => {
  const [isReady, setIsReady] = useState(!imageUrl);
  const [prevUrl, setPrevUrl] = useState(imageUrl);

  // Synchronously reset state if URL changes to prevent UI flicker
  if (imageUrl !== prevUrl) {
    setPrevUrl(imageUrl);
    setIsReady(!imageUrl); // If no URL, ready immediately. If URL, not ready.
  }

  useEffect(() => {
    if (!imageUrl) {
      setIsReady(true);

      return;
    }

    const img = new Image();
    img.src = imageUrl;

    // Check cache immediately
    if (img.complete) {
      setIsReady(true);
    } else {
      const onLoad = () => setIsReady(true);
      img.onload = onLoad;
      img.onerror = onLoad; // If error, mark ready so we don't block UI
    }
  }, [imageUrl]);

  return isReady;
};
